$(document).ready(function(){
    var elements = $('.core-copy p, .core-copy li, .spirit-subtitle, .video-wrapper, .main_text, .std_subtitle, .socialShare');

    function addWaypoints() {
        elements.waypoint({
          handler: function(direction) {
            TweenMax.fromTo($(this.element), 0.5, { ease: Power1.easeIn, y: 50 }, { opacity: 1, y: 0 });
            this.destroy();
          },
          offset: '90%'
        });

        $('.quote').waypoint({
          handler: function(direction) {
            TweenMax.fromTo($(this.element), 0.5, { ease: Power1.easeIn, x: '-15%' }, { opacity: 1, x: '0%' });
            this.destroy();
          },
          offset: '90%'
        });

        $('.featured-content-row').waypoint({
          handler: function(direction) {
            TweenMax.staggerFromTo($(this.element).find('.hero-feature'), 0.5, { ease: Power1.easeIn, x: '30%', opacity: 0 }, { opacity: 1, x: '0%' }, 0.1);
            this.destroy();
          },
          offset: '90%'
        });
    }

    $('.page-content-wrapper').waypoint({
      handler: function(direction) {
        TweenMax.fromTo($('.page-content-wrapper'),
                            0.5,
                            { ease: Power1.easeIn, y: 30 },
                            { opacity: 1, y: 0, delay: 0.5, onComplete:addWaypoints }
                        );
        this.destroy();
      },
      offset: '90%'
    });
});

$(document)
    .ready(function () {
        // Run start up scripts for this page
        TECL_SearchBar.InitialiseSearchBars();
        TECL_Animation.InitialiseAnimations();
        TECL_Hamburger.InitialiseNavigation();
        TECL_FAQ.Initialise();

        $(".thumbnail-description").dotdotdot();
        $('.featuredContentCarousel')
            .carousel({
                interval: 6000
            });
        $('.caption').on("mouseover", function() {
            $(".thumbnail-description").trigger("update");
        })
    });

$(document).ready(function() {
    //$(".switch-toggle").each(function() {
    //    $(this).css("width", $(this).siblings(".switch-label.active").outerWidth() + 10);
    //});

    $(".navigation-mobile-toggle").click(function() {
      if($(this).siblings(".navigation-items-wrapper").hasClass("open")) {
        $(this).siblings(".navigation-items-wrapper").removeClass("open");
      } else {
        $(this).siblings(".navigation-items-wrapper").addClass("open");
      }
    });

    //$('.switch-label').click(function(e) {
    //  if(!$(this).hasClass("active")) {
    //    $(this).siblings().removeClass("active");
    //    $(this).addClass("active");
    //    $(this).siblings(".switch-toggle").css("left", $(this).position().left + 5);
    //    $(this).siblings(".switch-toggle").css("width", $(this).width() + 10);

    //    $($(this).attr("data-target")).addClass("active");
    //    $($(this).siblings(".switch-label").attr("data-target")).removeClass("active");
    //    $("#tenderGrid, #challengeGrid").find(".animated, .spirit-title").css("opacity", 0);
    //    $("#tenderGrid, #challengeGrid").find(".home-step").removeClass("visible");
    //    setTimeout(function() {
    //      createSubGridAnimations();
    //    }, 100);
    //  }
    //});

    $("#find-out-more").click(function(e){
      e.preventDefault();
      $("html, body").animate({ scrollTop: $("#how-it-works").offset().top });
    })

    $(".home-hero .home-hero-content").waypoint({
      handler: function(direction) {
        TweenMax.fromTo(
          $(this.element),
          0.5,
          { ease: Power1.easeIn, x: -100 },
          { opacity: 1, x: 0 }
        );
        this.destroy();
      },
      offset: '90%'
    });

    $(".main-ctas").waypoint({
      handler: function(direction) {
          TweenMax.fromTo(
          $(this.element).find(".start-tender, .challenge-market"),
          0.5,
          { ease: Power1.easeIn, x: -100 },
          { opacity: 1, x: 0 }
        );
        this.destroy();
      },
      offset: '90%'
    });

    $(".how-it-works").waypoint({
      handler: function(direction) {
        TweenMax.fromTo(
          $(this.element),
          0.5,
          { ease: Power1.easeIn, y: -100 },
          { opacity: 1, y: 0 }
        );
        this.destroy();
      },
      offset: '70%'
    });

    $(".switch").waypoint({
        handler: function(direction) {
            TweenMax.staggerFromTo(
              $(this.element).find(".switch-label"),
              0.5,
              { ease: Power1.easeIn, x: -100 },
              { opacity: 1, x: 0 },
              -0.2,
              function() {

                  //TweenMax.fromTo(
                  //  $(this.element).find(".switch-toggle"),
                  //  0.5,
                  //  { ease: Power1.easeIn },
                  //  { opacity: 1 }
                  //);

                  createSubGridAnimations();
              },
              null,
              this
            );

            this.destroy();
        },
        offset: '70%'
    });

    $(".signup-form").waypoint({
      handler: function(direction) {
        TweenMax.fromTo(
          $(this.element),
          0.5,
          { ease: Power1.easeIn, y: -100 },
          { opacity: 1, y: 0 }
        );
        this.destroy();
      },
      offset: '80%'
    });
  });

  function createSubGridAnimations() {
    $("#tenderGrid.active .home-step:first-of-type").waypoint({
      handler: function(direction) {
        if(direction === "down") {
          $(".next-step-guide").show();
          TweenMax.fromTo(
            $(".next-step-guide"),
            0.5,
            { ease: Power1.easeIn, opacity: 0, y: -100 },
            { opacity: 1, y: 0 }
          );
        } else {
          TweenMax.fromTo(
            $(".next-step-guide"),
            0.5,
            { ease: Power1.easeIn, opacity: 1, y: 0 },
            { opacity: 0, y: 100 }
          );
        }
      },
      offset: '90%'
    });

    $("#tenderGrid.active .btn").waypoint({
      handler: function(direction) {
        if(direction === "down") {
          TweenMax.fromTo(
            $(".next-step-guide"),
            0.5,
            { ease: Power1.easeIn, opacity: 1, y: 0 },
            { opacity: 0, y: 100 }
          );
        }
      },
      offset: '100%'
    });

    $(".spirit-title").waypoint({
      handler: function(direction) {
        TweenMax.fromTo(
          $(this.element),
          0.5,
          { ease: Power1.easeIn, y: -25 },
          { opacity: 1, y: 0 }
        );
        this.destroy();
      },
      offset: '80%'
    });

    $(".howto-cta").waypoint({
      handler: function(direction) {
        TweenMax.fromTo(
          $(this.element),
          0.3,
          { ease: Power1.easeIn, y: -25 },
          { opacity: 1, y: 0 }
        );
        this.destroy();
      },
      offset: '80%'
    });

    $(".home-step:even").each(function() {
      $(this).waypoint({
        handler: function(direction) {
          $(this.element).addClass("visible");
          TweenMax.fromTo(
            $(this.element),
            0.5,
            { ease: Power1.easeIn, x: 100, opacity: 0 },
            { opacity: 1, x: 0 }
          );
          this.destroy();
        },
        offset: '70%'
      });
    });

    $(".home-step:odd").each(function() {
      $(this).waypoint({
        handler: function(direction) {
          $(this.element).addClass("visible");
          TweenMax.fromTo(
            $(this.element),
            0.5,
            { ease: Power1.easeIn, x: -50, opacity: 0 },
            { opacity: 1, x: 0 }
          );
          this.destroy();
        },
        offset: '70%'
      });
    });

    $(".next-step-guide").on("click", function() {
        var activeGrid = "#tenderGrid";
      var visibleSteps = $(activeGrid + ".active .home-step.visible");
      if(visibleSteps.length > 0) {
        var lastVisibleTop1 = visibleSteps.last().offset().top + 160;
        $("html, body").animate({ scrollTop: lastVisibleTop1 });
      } else {
        var lastVisibleTop2 = $(activeGrid + " .home-step:first-of-type").offset().top;
        $("html, body").animate({ scrollTop: lastVisibleTop2 });
      }
    });
  }

$(document).ready(function() {
  $(".hero-feature").each(function (){
    var element = $(this);

    var titleHeight = element.find("h3").height();
    var tileHeight = element.height();
    var overlayTop = parseInt(element.find(".item-content").css("top"));
    var overlayRemainder = tileHeight - overlayTop;
    var titlePadding = 20;

    if(overlayRemainder < titleHeight) {
      var newOverlayTop = tileHeight - titleHeight - titlePadding;
      element.find(".item-content").css("top", newOverlayTop);
    }

    element.find(".item-description").dotdotdot({
        height: function() {
            var itemDate = element.find(".item-date").outerHeight(true);
            var itemAuthor = element.find(".item-author").outerHeight(true);
            return tileHeight - titleHeight - titlePadding - itemAuthor - itemDate;
        }
    });
  });
});

$( document ).ready( function() {
    $( ".case-study-col, .product-col" ).matchHeight();
} );

$( document ).ready( function() {
  function acceptCookies ( callback ) {
    $.post( "/umbraco/Surface/CookiesSurface/AcceptCookies",
      function( data ) {
        if ( data.ResultData ) {
          console.log( "Cookies accepted successfully." );
        } else {
          console.error( "Error accepted cookies." );
        }
      } );

    if ( callback ) {
      callback();
    }
  }

  function denyCookies ( callback ) {
    $.post( "/umbraco/Surface/CookiesSurface/DenyCookies",
      function( data ) {
        if ( data.ResultData ) {
          console.log( "Cookies denied successfully." );
        } else {
          console.error( "Error denying cookies." );
        }
      } );

    if ( callback ) {
      callback();
    }
  }

  window.cookieconsent.initialise( {
    position: "top",
    static: true,
    content: {
      message: "We use cookies on our website to enable some essential functions for you in " +
      "accordance with our <a href=\"/main-site-navigation/cookie-policy/\">cookie policy</a>. We'd also like your " +
      "permission to store cookies to help us understand how visitors are using our website  " +
      "so we can improve the experience for them.",
      deny: "No thanks",
      allow: "That's ok",
      href: "/main-site-navigation/cookie-policy/"
    },
    showLink: false,
    type: "opt-in",
    compliance: {
      "opt-in": "<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>"
    },
    onStatusChange: function() {
      var didConsent = this.hasConsented();

      if ( didConsent ) {
        acceptCookies();
      }
      if ( !didConsent ) {
        denyCookies();
      }
    },
    onRevokeChoice: function() {
      var type = this.options.type;

      if ( type === "opt-in" ) {
        acceptCookies();
      }
      if ( type === "opt-out" ) {
        denyCookies();
      }
    }
  } );
} );
